<div #list (ppOnRendered)="onTableRendered($event)" (scroll)="scrollHandler($event)">
  @if (ppItem.subList?.length === 0 && ppFilter !== '') {
    <div (click)="$event.stopPropagation()">
      <p class="listCF__not-found-message">
        {{ 'no_search_result' | ppTranslate }}
      </p>
    </div>
  }

  <div class="checkboxContainer">
    <div class="listCFs_wrapper">
      @for (item of ppItem.subList; track item) {
        @if (item.label && visibleIds.includes(item.id)) {
          <div
            class="listCF__list-item"
            (click)="select(item); $event.stopPropagation()"
            >
            <button
              (click)="toggleExpand(item); $event.stopPropagation()"
              class="listCF__list__chevronWrapper"
              >
              @if (item.subList?.length > 0) {
                <pp-icon
              [ppSrc]="
                expanded[item.id]
                  ? EIconPath.ICON_NAV_ARROW_DOWN_18
                  : EIconPath.ICON_NAV_ARROW_RIGHT_18
              "
                  ppClass="setSize18"
                  ppColor="grey-700"
                ></pp-icon>
              }
            </button>
            <pp-checkbox
              [ppChecked]="isSelected(item.id)"
              [ppHalfChecked]="isHalfSelected(item)"
              ppType="solid"
              ppSize="medium"
            ></pp-checkbox>
            <label>
              {{ item.label }}
            </label>
            @if (!expanded[item.id] && item.subList?.length > 0) {
              <p class="listCF__sublist-count">
                ({{ item.subList?.length }})
              </p>
            }
          </div>
        }
        @if (item.subList?.length > 0 && expanded[item.id]) {
          <div class="listCF__sublist-wrapper">
            <pp-custom-field-multi-list-select
              class="listCF__sublist"
              [ppItem]="item"
              [ppFilter]="ppFilter"
              [ppSelectedIds]="ppSelectedIds"
              (ppSelect)="select($event)"
            ></pp-custom-field-multi-list-select>
          </div>
        }
      }
    </div>
  </div>
</div>
